import { useSelector } from '../actions/types';
import { HomePageQuery } from '@elevio-kb/queries/dist/types';
import * as selectors from '../selectors';

export type IHome = HomePageQuery;

type Result = {
  fetchingStatus: selectors.FetchingStatus;
  data: IHome | null;
};

export default function useHomePageData(): Result {
  const fetchingStatus = useSelector(state =>
    selectors.homePageFetchingStatus(state)
  );
  const data = useSelector(state => selectors.getHomePageData(state));
  return {
    fetchingStatus,
    data,
  };
}
